import { PayloadAction } from '@reduxjs/toolkit';

import { VariantsState } from 'editor/src/store/variants/types';

const setDisplayedSizeReducer = (state: VariantsState, action: PayloadAction<string | undefined>) => {
  state.displayedSize = action.payload;
};

export default setDisplayedSizeReducer;
